/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancelled_BadgeInputs */



/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Rounds_Cancelled_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancelled_badge = /** @type {((inputs?: Rounds_Cancelled_BadgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancelled_BadgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annulée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullato")
	return /** @type {LocalizedString} */ ("Cancelled")
});